import { useState, useContext, useEffect } from 'react'
import "./style.scss"
import { toAbsoluteUrl } from "../../utils/assetHelper"
import { isAvailableRoute } from '../../utils/permissions'
import Input from "../../components/Input"
import { AuthContext } from '../../context/auth'
import { useNavigate } from 'react-router-dom'
import { Checkbox } from '../../components/Checkbox'
import { loginApi, currentUserApi } from '../../api'
import { setLocalStorage, getLocalStorage, removeLocalStorage } from '../../helpers/localStorage'


const Index = () => {
  const navigate = useNavigate()
  const { login, setIsLoading } = useContext(AuthContext)
  // const [isLoading, setIsLoading] = useState(false)
  const [Email, setEmail] = useState('')
  const [Password, setPassword] = useState('')
  const [rememberMe, setRememberMe] = useState(false)
  const [error, setError] = useState('')


  useEffect(() => {
    if (getLocalStorage('rememberMe')) {
      setEmail(getLocalStorage('rememberMe', true).email)
      setPassword(getLocalStorage('rememberMe', true).password)
      setRememberMe(true)
    } else {
      setRememberMe(false)
    }
  }, [])

  useEffect(() => {
    if (getLocalStorage('identifynadmintoken')) {
      navigate('/products/primary-antibodies')
    }
  }, [getLocalStorage('identifynadmintoken')])


  const Login = () => {
    setIsLoading(true)
    if (/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(Email)) {
      if (rememberMe) {
        const data = {
          email: Email,
          password: Password,
          expiry: new Date().getTime() + 1000 * 60 * 60 * 24
        }
        setLocalStorage('rememberMe', data, true)
      } else {
        removeLocalStorage('rememberMe')
      }
      loginApi({ email: Email, password: Password }).then((res) => {
        if (res?.data?.access_token) {
          setLocalStorage('identifynadmintoken', res?.data?.access_token)
          currentUserApi().then((user) => {
            const userData = user?.data
            const permissions = userData?.user?.teamRole?.permissions[0]?.metadata
            const redirectRoute = isAvailableRoute(permissions, '/products/primary-antibodies', 'GET', userData?.user?.id)
            login(userData)
            navigate(redirectRoute)
            setIsLoading(false)
            setError('')
            setEmail('')
            setPassword('')
          })
        } else {
          setError("Invalid Email or Password")
          setIsLoading(false)
        }
      }).catch((err) => {
        setError("Invalid Email or Password")
        setIsLoading(false)
      })
    } else {
      setError('Please enter a valid Email Address')
      setIsLoading(false)
    }
  }


  return (
    <div>
      <div className="signin-container">
        <div className="left-container">
          <span style={{ width: '44px', height: '44px', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '12px', background: '#fff2e5', color: 'var(--primary-color)' }}>
            <i class="fas fa-sign-in" style={{fontWeight:'300' }}></i>
          </span>
          <div>
            <h1>Welcome to IDENTiFYN™</h1>
            <p>Please login to continue.</p>
          </div>
          <div className="form-container">
            <Input type='email' style={{ marginBottom: '20px', height:'74px', padding:Email ? '18px 16px 0 12px' : '12px 16px' }} className={"Email"} label={'Email'} value={Email} required onChange={(e) => setEmail(e.target.value)} />
            <Input type='password' style={{height:'74px' }} placeholder={'Password'} value={Password} onChange={(e) => setPassword(e.target.value)} onKeyPress={(e) => e.key === 'Enter' && Login()} />
            <div class="checkbox-container">
              {/* <input type="checkbox" id="myCheckbox" class="checkbox" />
              <label for="myCheckbox" class="checkbox-label">Remember me?</label> */}
              <Checkbox
                label='Remember me?'
                checked={rememberMe}
                onChange={(e) => {
                  if (e.target.checked) {
                    setRememberMe(true)
                  } else {
                    setRememberMe(false)
                  }
                }}
              // id='disable-all'
              />
            </div>

          </div>
          {error && <h4 style={{ color: '#DC1E00', textAlign: 'center', fontWeight: 500 }}>{error}</h4>}
          <button className="btn sign-in-btn" disabled={!Email || !Password} onClick={() => {
            Login()
          }
          }>Login</button>
        </div>
        <div className="right-container overlay">
          <img src={toAbsoluteUrl('/media/logowhite.png')} alt="" />
          <div className="content">
            <h3><span>SUPER RESOLUTION</span> <br /> LABORATORIES</h3>
            <p>Delivering unprecedented power, speed, and access to multimodal super resolution microscopy, reagents, applications, and discovery.</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Index